<template>
    <div class="count">
        <h1>人员统计</h1>
        <div class="liall">
            <div class="tab">
                <ul>
                    <li :class="{on:on===1}" @click="on=1">全部成员</li>
                    <li :class="{on:on===2}" @click="on=2">血亲成员</li>
                    <li :class="{on:on===3}" @click="on=3">男性成员</li>
                </ul>
            </div>
            <template v-if="on===1">
                <div class="jg">
                    我的家谱，共<span>{{ totalPerson }}</span>人，男<span>{{ maleNum }}</span>，女<span>{{ femaleNum }}</span>，健在<span>{{
                    liveNum
                }}</span>，已故<span>{{ deathNum }}</span>
                </div>
                <ul class="lists" v-if="familyLevelData">
                    <li v-for="item in familyLevelData">
                        <div style="display: flex;align-items: center;background: #ddd;padding: 15px;">{{ item.level
                            }}世，共
                            <el-badge :value="item.person.length"></el-badge>
                            人，男
                            <el-badge type="primary" :value="getMaleNum(item.person)"></el-badge>
                            ，女
                            <el-badge :value="getFemaleNum(item.person)"></el-badge>
                            ，健在
                            <el-badge type="success" :value="getLiveNum(item.person)"></el-badge>
                            ，已故
                            <el-badge type="info" :value="getDeathNum(item.person)"></el-badge>
                        </div>
                        <div class="list" v-for="it in item.person"
                             style="display: flex;align-items: center;padding: 15px;background: #fff;border-bottom: solid 1px #ddd;">
                            <div class="img" :class="whichGender(it)">
                                <i class="tx" v-if="it.photo"><img :src="it.photo"></i>
                            <i class="el-icon-user-solid" v-else></i>
                            </div>
                            <div class="name" style="flex-shrink: 0;flex-grow: 1;">{{ it.name }}<span
                                    class="gray">（{{ checkSay(it) }}）</span>
                            </div>
                            <div class="gender" :class="whichGender(it)" style="width: 60px;text-align: center">
                                {{ it.gender === 'male' ? '男' : '女' }}
                            </div>
                            <div class="death" :class="{gray:it.deathDate}" style="width: 60px;text-align: center">{{
                                it.deathDate === '' ? '健在' : '已故' }}
                            </div>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="on===2">
                <div class="jg">
                    我的家谱，共<span>{{ totalPerson }}</span>人，男<span>{{ maleNum }}</span>，女<span>{{ femaleNum }}</span>，健在<span>{{
                    liveNum
                }}</span>，已故<span>{{ deathNum }}</span>
                </div>
                <ul class="lists" v-if="familyLevelData">
                    <li v-for="item in familyLevelData">
                        <div style="display: flex;align-items: center;background: #ddd;padding: 15px;">{{ item.level
                            }}世，共
                            <el-badge :value="item.person.length"></el-badge>
                            人，男
                            <el-badge type="primary" :value="getMaleNum(item.person)"></el-badge>
                            ，女
                            <el-badge :value="getFemaleNum(item.person)"></el-badge>
                            ，健在
                            <el-badge type="success" :value="getLiveNum(item.person)"></el-badge>
                            ，已故
                            <el-badge type="info" :value="getDeathNum(item.person)"></el-badge>
                        </div>
                        <div class="list" v-for="it in item.person"
                             style="display: flex;align-items: center;padding: 15px;background: #fff;border-bottom: solid 1px #ddd;">
                            <div class="img" :class="whichGender(it)">
                                <i class="tx" v-if="it.photo"><img :src="it.photo"></i>
                            <i class="el-icon-user-solid" v-else></i>
                            </div>
                            <div class="name" style="flex-shrink: 0;flex-grow: 1;">{{ it.name }}<span
                                    class="gray">（{{ checkSay(it) }}）</span>
                            </div>
                            <div class="gender" :class="whichGender(it)" style="width: 60px;text-align: center">
                                {{ it.gender === 'male' ? '男' : '女' }}
                            </div>
                            <div class="death" :class="{gray:it.deathDate}" style="width: 60px;text-align: center">{{
                                it.deathDate === '' ? '健在' : '已故' }}
                            </div>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-else-if="on===3">
                <div class="jg">
                    我的家谱，共<span>{{ totalPerson }}</span>人，健在<span>{{
                    liveNum
                }}</span>，已故<span>{{ deathNum }}</span>
                </div>
                <ul class="lists" v-if="familyLevelData">
                    <li v-for="item in familyLevelData">
                        <div style="display: flex;align-items: center;background: #ddd;padding: 15px;">{{ item.level
                            }}世，共
                            <el-badge :value="item.person.length"></el-badge>
                            人，男
                            <el-badge type="primary" :value="getMaleNum(item.person)"></el-badge>
                            ，女
                            <el-badge :value="getFemaleNum(item.person)"></el-badge>
                            ，健在
                            <el-badge type="success" :value="getLiveNum(item.person)"></el-badge>
                            ，已故
                            <el-badge type="info" :value="getDeathNum(item.person)"></el-badge>
                        </div>
                        <div class="list" v-for="it in item.person"
                             style="display: flex;align-items: center;padding: 15px;background: #fff;border-bottom: solid 1px #ddd;">
                            <div class="img" :class="whichGender(it)">
                                <i class="tx" v-if="it.photo"><img :src="it.photo"></i>
                            <i class="el-icon-user-solid" v-else></i>
                            </div>
                            <div class="name" style="flex-shrink: 0;flex-grow: 1;">{{ it.name }}<span
                                    class="gray">（{{ checkSay(it) }}）</span>
                            </div>
                            <div class="gender" :class="whichGender(it)" style="width: 60px;text-align: center">
                                {{ it.gender === 'male' ? '男' : '女' }}
                            </div>
                            <div class="death" :class="{gray:it.deathDate}" style="width: 60px;text-align: center">{{
                                it.deathDate === '' ? '健在' : '已故' }}
                            </div>
                        </div>
                    </li>
                </ul>
            </template>

        </div>
        <div class="tools">
            <router-link :to="'/family/'+routeId" class="to to1">
                <span><img src="@/assets/tree.png"> </span>
            </router-link>
            <router-link to="/" class="to to3">
                <i class="el-icon-s-home"></i>
            </router-link>
        </div>
    </div>
</template>

<script>
    //https://www.jb51.net/article/211967.htm
    export default {
        name: 'count',
        data() {
            return {
                familyTree: null,
                familyLevelData: null,
                familyPlainData: null,
                on: 1,
                routeId: this.$route.params.id
            }
        },
        computed: {
            totalPerson() {
                if (this.familyPlainData) {
                    return this.familyPlainData.length
                }
            },
            maleNum() {
                if (this.familyPlainData) {
                    let fi = this.familyPlainData.filter((el) => {
                        return el.gender === 'male'
                    })
                    return fi.length
                }
            },
            femaleNum() {
                if (this.familyPlainData) {
                    let fi = this.familyPlainData.filter((el) => {
                        return el.gender === 'female'
                    })
                    return fi.length
                }
            },
            liveNum() {
                if (this.familyPlainData) {
                    let fi = this.familyPlainData.filter((el) => {
                        return el.deathDate === ''
                    })
                    return fi.length
                }
            },
            deathNum() {
                if (this.familyPlainData) {
                    let fi = this.familyPlainData.filter((el) => {
                        return el.deathDate != ''
                    })
                    return fi.length
                }
            },


        },
        created() {
        },
        watch: {
             $route: {
                handler(route) {
                    this.routeId = route.params.id
                    if (this.$store.state.family.family === null) {
                        this.$store.dispatch('family/getAll').then((rs) => {
                            let fi = rs.filter((el) => {
                                return el.id == this.routeId
                            })
                            this.familyTree = fi[0].tree
                        })
                    } else {
                        let fi = this.$store.state.family.family.filter((el) => {
                            return el.id == this.routeId
                        })
                        this.familyTree = fi[0].tree
                    }

                },
                immediate: true
            },
            familyTree: {
                immediate: true,
                handler(value) {
                    if (value) {

                        //转为PLAIN数据
                        let array = []
                        const {id, name, photo, gender, parent, details, birthDate, deathDate} = value;
                        array.push({id, name, photo, gender, parent, details, birthDate, deathDate});

                        value.spouse.forEach((sp) => {
                            const {id, spid, name, photo, gender, details, birthDate, deathDate} = sp; // 解构并保留其他属性
                            array.push({id, spid, name, photo, gender, details, birthDate, deathDate});
                        })

                        let fi1 = this.treeToFlat(value.children, [])
                        array.push(...fi1)
                        this.familyPlainData = array
                        //转为Level数据

                        let fi2 = this.convertToLevelStructure(array)
                        this.familyLevelData = fi2
                        //console.log(fi2)

                    }
                }
            },
            on: {
                immediate: false,
                handler(value) {
                    let data = this.familyTree
                    if (value === 1) {
                        let array = []
                        const {id, name, photo, gender, parent, details, birthDate, deathDate} = data;
                        array.push({id, name, photo, gender, parent, details, birthDate, deathDate});

                        data.spouse.forEach((sp) => {
                            const {id, spid, name, photo, gender, details, birthDate, deathDate} = sp; // 解构并保留其他属性
                            array.push({id, spid, name, photo, gender, details, birthDate, deathDate});
                        })

                        let fi1 = this.treeToFlat(data.children, [])
                        array.push(...fi1)
                        this.familyPlainData = array
                        let fi2 = this.convertToLevelStructure(array)
                        this.familyLevelData = fi2
                        //console.log(fi2)

                    }

                    if (value === 2) {
                        let array = []
                        const {id, name, photo, gender, parent, details, birthDate, deathDate} = data;
                        array.push({id, name, photo, gender, parent, details, birthDate, deathDate});
                        let fi1 = this.treeToFlat2(data.children, [])
                        array.push(...fi1)
                        this.familyPlainData = array

                        let fi2 = this.convertToLevelStructure(array)
                        this.familyLevelData = fi2


                    }
                    if (value === 3) {
                        let array = []
                        const {id, name, photo, gender, parent, details, birthDate, deathDate} = data;
                        if (gender === 'male') {
                            array.push({id, name, photo, gender, parent, details, birthDate, deathDate});
                        }
                        let fi1 = this.treeToFlat3(data.children, [])
                        array.push(...fi1)
                        this.familyPlainData = array
                        //console.log(array)

                        let fi2 = this.convertToLevelStructure(array)
                        this.familyLevelData = fi2

                    }
                }
            },

        },
        methods: {
            treeToFlat(tree, result = []) {
                tree.forEach(node => {
                    const {id, name, photo, gender, parent, spouse, details, children, birthDate, deathDate} = node; // 解构并保留其他属性
                    result.push({id, name, photo, gender, parent, details, birthDate, deathDate});
                    spouse.forEach((sp) => {
                        const {id, spid, name, photo, gender, details, birthDate, deathDate} = sp; // 解构并保留其他属性
                        result.push({id, spid, name, photo, gender, details, birthDate, deathDate});
                    })
                    if (children && children.length > 0) {
                        this.treeToFlat(children, result);
                    }
                });
                return result;
            },
            treeToFlat2(tree, result = []) {
                tree.forEach(node => {
                    const {id, name, photo, gender, parent, details, children, birthDate, deathDate} = node; // 解构并保留其他属性
                    result.push({id, name, photo, gender, parent, details, birthDate, deathDate});
                    if (children && children.length > 0) {
                        this.treeToFlat2(children, result);
                    }
                });
                return result;
            },
            treeToFlat3(tree, result = []) {
                tree.forEach(node => {
                    if (node.gender === 'male') {
                        const {id, name, photo, gender, parent, details, children, birthDate, deathDate} = node; // 解构并保留其他属性
                        result.push({id, name, photo, gender, parent, details, birthDate, deathDate});

                        if (children && children.length > 0) {
                            this.treeToFlat3(children, result);
                        }
                    }
                });
                return result;
            },
            convertToLevelStructure(flatList) {
                // 1. 先计算每个节点的层级 level
                const getLevel = (id) => {
                    const node = flatList.find(item => item.id === id);
                    if (!node) return 0;
                    if (node.parent === '') return 1;
                    if (node.spid) {
                        return getLevel(node.spid)
                    }
                    return getLevel(node.parent) + 1;
                };

                // 2. 给每个节点加上 level
                const listWithLevel = flatList.map(item => ({
                    ...item,
                    level: getLevel(item.id)
                }));

                // 3. 按 level 分组，生成目标结构
                const maxLevel = Math.max(...listWithLevel.map(item => item.level));
                const result = [];

                for (let level = 1; level <= maxLevel; level++) {
                    const person = listWithLevel.filter(item => item.level === level);
                    result.push({
                        level,
                        person
                    });
                }

                return result;
            },
            getMaleNum(node) {
                let fi = node.filter((el) => {
                    return el.gender === 'male'
                })
                return fi.length

            },
            getFemaleNum(node) {
                let fi = node.filter((el) => {
                    return el.gender === 'female'
                })
                return fi.length

            },
            getLiveNum(node) {
                let fi = node.filter((el) => {
                    return el.deathDate === ''
                })
                return fi.length

            },
            getDeathNum(node) {
                let fi = node.filter((el) => {
                    return el.deathDate !== ''
                })
                return fi.length

            },
            whichGender(it) {

                return it.gender === 'male' ? 'male' : 'female'

            },
            checkSay(node) {
                if (this.familyTree) {
                    let wc = node.gender === 'male' ? '儿子' : '女儿'
                    let sp = node.gender === 'male' ? '丈夫' : '妻子'
                    if (node.parent === '') {
                        return '始祖'
                    } else {
                        if (node.spid) {
                            let fi = this.findNodeById(this.familyTree, node.spid)
                            return fi.name + '的' + sp

                        } else {
                            let fi = this.findNodeById(this.familyTree, node.parent)
                            return fi.name + '的' + wc

                        }
                    }
                }
            },
            findNodeById(tree, id) {
                if (tree.id === id) {
                    return tree; // 找到匹配的节点，返回它
                } else if (tree.children) { // 检查是否有子节点
                    for (let child of tree.children) {
                        const result = this.findNodeById(child, id); // 递归搜索子节点
                        if (result) {
                            return result; // 如果在子节点中找到，返回该节点
                        }
                    }
                }
                return null; // 没有找到匹配的节点
            },
        }
    }
</script>
<style scoped>
    .count {
        padding: 3vw;
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .gray {
        color: #999;
    }

    .liall {
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
    }

    .liall .jg {
        background: #fdf6ec;
        border: 1px solid #f5dab1;
        padding: 15px;
    }

    .liall .jg span {
        color: #f56c6c;
        font-weight: 700;
    }

    .liall .lists {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .liall .tab {
        position: sticky;
        top: 0;
        z-index: 9;
        background: var(--bg);
    }

    .liall .tab ul {
        display: flex;
        font-size:clamp(18px,1.5vw,24px);
        gap: 15px;
        position: relative;font-weight: 500;
    }

    .liall .tab ul:before {
        content: '';
        background: #aaa;
        height: 1px;
        position: absolute;
        width: 100%;
        bottom: 0;
    }

    .liall .tab ul li {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;
        border: solid 1px #aaa;
        border-bottom: none;
        background: var(--white);
        cursor: pointer;
    }

    .liall .tab ul li.on {
        color: #f56c6c;
        background: #fdf6ec;
        border-color: #f56c6c;
        position: relative;
        z-index: 1;
    }

    .liall .list .img i{
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        overflow: hidden;
        background: #eee;
        margin-right: 5px;
    }
    .liall .list .img i img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .el-badge {
        display: flex;
        align-items: center;
    }

    .male {
        color: var(--mline);
        background: none;
        border: none
    }

    .male i {
        color: var(--mline);
    }

    .female {
        color: var(--fline);
        background: none;
        border: none
    }

    .female i {
        color: var(--fline);
    }

    h1 {
        font-size: clamp(18px, 10vw, 50px);
        display: flex;
        justify-content: center;
    }


</style>

